import { useStoreFillter } from 'pages/Accounts/Report/TransactionDetail/utils'
import React from 'react'
import { Link } from 'react-router-dom'
import { convertNumber } from 'utils'

type ColumnSectionProps = {
  key: React.Key
  balance: number
  isNormalFontWeight: boolean,
  isPNL?: boolean
  isDetail?: boolean
  account?: string
  startDate?: string
  endDate?: string
}

export const ColumnSection = ({ key, balance, isNormalFontWeight, isPNL, isDetail, account, startDate, endDate }: ColumnSectionProps) => {

  const { setFilter } = useStoreFillter()

  return (
    <>
      {isDetail ? (
        <td
          key={key}
          className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
          <span className='e-2 text-nowrap cursor-pointer p-2  rounded-lg hover:bg-slate-200'>
            <Link
              to="/accounts/report/transaction-detail"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                setFilter((prev) => ({
                  ...prev,
                  coa: [account ?? ""],
                  start_date: startDate ?? "",
                  end_date: endDate ?? "",
                  location_id: "0",
                }))
              }}
            >
              {convertNumber(balance).intoCurrency}
            </Link>
          </span>
        </td>
      ) : (
        <td
          key={key}
          className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
          {convertNumber(balance).intoCurrency}
        </td>

      )}
    </>
  )
}